import { Children, type PropsWithChildren } from "react";

export function FormRow({ children }: PropsWithChildren) {
  return (
    <div className="flex gap-2">
      {Children.map(children, (child) =>
        child ? <div className="flex-1">{child}</div> : null,
      )}
    </div>
  );
}
